import { _default, Context } from "@max/index"
export { initDSL, register, registerRouter } from '@max/index'
export const createMax = (localMap: Record<string, any>, isPage: boolean, shortKey = '') => {
  const local = Context(localMap, isPage, shortKey)
  return new Proxy({}, {
    has: () => true,
    get: (_, name: string) => {
      if (name === 'dispose') {
        return (local as any).dispose
      }
      if (name === 'i18n') {
        return {
          ..._default.max.i18n,
          ...local.max.i18n,
        }
      }
      if (local.max[name]) {
        return local.max[name]
      }
      return _default.max[name] || undefined
    }
  })
}
export const rootMax: any = new Proxy({}, {
  has: () => true,
  get: (_, name: string) => {
    return _default.max[name] || undefined
  }
})

// 1. 先初始化
// 2. 然后注册相应环境的api
// 3. 创建max
